import { memo } from "react";
import { useAutomation } from "../../hooks/useAutomation";

/** Place useAutomation in a memo component, so it prevents the rerende of the entire App */
export const Automation = memo(function Automation() {
	useAutomation();
	return null;
});
